/* eslint-disable prefer-arrow-callback */
// Helper to sanitize and normalize HTML content before sending to the server or inserting into editors.
// - Uses DOMPurify to strip unsafe tags/attributes
// - Converts rgb()/rgba() colors to 6- or 8-digit hex (alpha converted to 2-digit hex when present)
import DOMPurify from 'dompurify';

export function cleanHtmlContent(html) {
  if (!html) return html;

  const sanitizedHtml = DOMPurify.sanitize(html);

  return sanitizedHtml.replace(/rgba?\([^)]*\)/gi, match => {
    const parts = match
      .replace(/rgba?\(|\)/gi, '')
      .split(',')
      .map(p => {
        return p.trim();
      });

    let r;
    let g;
    let b;
    let a = 1;
    if (parts.length >= 3) {
      const parseComponent = comp => {
        if (comp.endsWith('%')) {
          return Math.round(Math.min(100, parseFloat(comp)) * 2.55);
        }
        return Math.round(Number(comp));
      };
      r = parseComponent(parts[0]);
      g = parseComponent(parts[1]);
      b = parseComponent(parts[2]);
      if (parts.length === 4) {
        a = parseFloat(parts[3]);
      }
    } else {
      return match;
    }

    const toHex = n => {
      return Math.max(0, Math.min(255, n)).toString(16).padStart(2, '0');
    };
    const rH = toHex(r);
    const gH = toHex(g);
    const bH = toHex(b);
    if (typeof a === 'number' && a >= 0 && a < 1) {
      const aH = Math.round(a * 255)
        .toString(16)
        .padStart(2, '0');
      return `#${rH}${gH}${bH}${aH}`;
    }

    return `#${rH}${gH}${bH}`;
  });
}
